module.exports = __webpack_public_path__ + "img/Komunikasi-Label0.6a544c00.png";